import React, { useState, useEffect, useRef } from "react";
import styles from "./states-modal.module.css";
import { MyIcons } from "../../icons/my-icons";
import Table from "../../ui/table";
import { getStates } from "../../../services/apiService";

const StatesModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getStates();
        setStates(statesData);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    if (isOpen) {
      fetchStates();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const headers = [
    { label: "Nombre", key: "nombre" },
    { label: "Días", key: "dias" },
  ];

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer} ref={modalRef}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Estados</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons
              name="close"
              width={24}
              height={24}
              color="black"
            />
          </button>
        </div>

        <div className={styles.tableSection}>
          <Table headers={headers} data={states} />
        </div>
      </div>
    </div>
  );
};

export default StatesModal;
